import type { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import { dehydrate, QueryClient } from '@tanstack/react-query';

import g from 'src/constants/urls';
import { IArticleByGroupDetail } from 'src/interface/ArticleByGroup';
import { ICategoryByGroupDetail } from 'src/interface/CategoryByGroup';
import wrapper from 'src/redux';
import { actionGetArticleByCategorySlug } from 'src/redux/actions/articleByGroup';

const HeadC = dynamic(() => import('src/components/Head'));
const ArticleDetailContainer = dynamic(() => import('src/containers/ArticlesDetail/index'));
const NewsArticleJsonLdC = dynamic(() => import('src/components/Layout/JsonLd/NewsArticle'));
const BreadCrumbJsonLd = dynamic(() => import('src/components/Layout/JsonLd/Breadcrumb'));
const JoinKomunitasDetailArtikelContainer = dynamic(
	() => import('src/containers/JoinKomunitasDetailArtikel'),
);

const SubCategoryPage = (props: any) => {
	const kehamilan = props.artikel;
	const metaTitle = !kehamilan.meta_title ? kehamilan.title : kehamilan.meta_title;
	const metaDescription = !kehamilan.meta_description
		? kehamilan.short_desc
		: kehamilan.meta_description;

	return (
		<>
			<HeadC title={metaTitle} description={metaDescription} pageItem={kehamilan} />
			<ArticleDetailContainer {...props} />
			<JoinKomunitasDetailArtikelContainer {...props} />

			<NewsArticleJsonLdC article={kehamilan} />
			<BreadCrumbJsonLd pageHeaderContent={props.pageHeaderContent} />
		</>
	);
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
	(store: any) => async (ctx: any) => {
		let isError: boolean = false;
		let artikel: any = {};
		let dataComments: any = [];
		let databaruComments: any = [];
		let artikelLainnya: any = [];
		let waCommunity: any = [];
		let categoryArtikel: any = [];
		let categoryExist: any;
		const queryClient = new QueryClient();
		const { req } = ctx;
		const query = ctx.params;
		const subCategorySlug = query.sub;
		const subCategorySlug2 = req.cookies.dCat ? `/category/${req.cookies.dCat}`: '';
		const uppercaseCount = (subCategorySlug.match(/[A-Z]/g) || []).length;

		try {
			const data = `${g.API_ARTICLE_SLUG}/articles/slug/${subCategorySlug.toLowerCase()}`;
			const optionsdata = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};
			const databaru = await fetch(data, optionsdata);
			databaruComments = await databaru.json().then((res) => ({ ...res, status: databaru.status }));
			if (databaruComments?.status === 301) {
				return {
					redirect: {
						destination: `/pra-kehamilan/${databaruComments.data.record.canonical}`,
						statusCode: 301,
					},
				};
			}
			artikel = await store.dispatch(await actionGetArticleByCategorySlug(subCategorySlug+subCategorySlug2));
			if (artikel.data.record.type !== 'pre-pregnancy' ) {
				const phase = artikel.data.record.type === 'post-pregnancy' ? 'pasca-kehamilan' : artikel.data.record.type === 'pre-pregnancy' ? 'pra-kehamilan' : artikel.data.record.type === 'recipe' ? 'resep' : 'kehamilan';
				return {
					redirect: {
						destination: `${process.env.NEXT_PUBLIC_WEB_URL}/${phase}/${subCategorySlug.toLowerCase()}`,
						statusCode: 301,
					},
				};
			}
			if (artikel.data.record.redirect_url) {
				return {
					redirect: {
						destination: `${process.env.NEXT_PUBLIC_WEB_URL}/${artikel.data.record.redirect_url}`,
						statusCode: 301,
					},
				};
			}
			if (uppercaseCount >= 1) {
				return {
					redirect: {
						destination: `/pra-kehamilan/${subCategorySlug.toLowerCase()}`,
						statusCode: 301,
					},
				};
			}
			if (!artikel?.data?.record) {
				return { notFound: true };
			}
			const filters = 'order=desc&orderby=total_like';
			const urlC = `${g.API_ARTICLE_SLUG}/articles/${artikel.data.record.uid}/comments?${filters}`;
			const optionsComments = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};
			const dc = await fetch(urlC, optionsComments);
			dataComments = await dc.json().then((res) => ({ ...res, status: dc.status }));

			const urlWA = `${g.API_EVENT}/settings/community-url`;
			const optsWA = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};
			const waCommunitys = await fetch(urlWA, optsWA);
			waCommunity = await waCommunitys.json().then((res) => ({ ...res, status: waCommunitys.status }));

			const uriCategory = `${g.API_ARTICLE_SLUG}/categories?type=pre-pregnancy&filter_groups=${!artikel.data.record.group_code ? 'trimester-1' : artikel.data.record.group_code}&order=asc&orderBy=sequence&is_show=true`;
			const optsCategory = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const cat = await fetch(uriCategory, optsCategory);
			categoryArtikel = await cat.json().then((res) => ({ ...res, status: cat.status }));
			categoryExist = categoryArtikel.data.records.some((item: any) => item.slug === artikel.data.record.category_slug);

			const url = `${g.API_ARTICLE}/pre-pregnancy?${filters}&per_page=3&page=1`;
			const opts = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const artLainnya = await fetch(url, opts);
			artikelLainnya = await artLainnya
				.json()
				.then((res) => ({ ...res, status: artLainnya.status }));
		} catch (err: any) {
			if (err?.status === 400) {
				isError = true;
				return { notFound: true };
			} else {
				throw err;
			}
		}
		const subCategories: ICategoryByGroupDetail[] = store.getState().categoryByGroup.subCategories;
		const category = subCategories.find(
			(sc) => sc.slug === subCategorySlug,
		) as ICategoryByGroupDetail;

		const article: IArticleByGroupDetail[] =
			store.getState().articleByGroup.articleByCategory?.data?.records;

		if ((!category || !article) && isError) return { notFound: true };
		return {
			props: {
				dehydratedState: dehydrate(queryClient),
				card: true,
				isWhiteBackground: false,
				JsonLd: {
					organization: true,
					breadcrumbs: true,
				},
				pageHeaderContent: {
					title: 'kehamilan',
					breadcrumbs: [
						{ label: 'Artikel', navigatePath: '/artikel' },
						{
							label: 'Pra Kehamilan',
							navigatePath: `/artikel/pra-kehamilan/${!artikel.data.record.group_code ? 'promil' : artikel.data.record.group_code}/${!artikel.data.record.category_slug ? 'buat-mama' : artikel.data.record.category_slug && categoryExist === false ? 'buat-mama' : artikel.data.record.category_slug}`,
						},
						// { label: artikel.data.record.group_name, navigatePath: `/artikel/pra-kehamilan/${artikel.data.record.group_code}` },
						// { label: artikel.data.record.category_name, navigatePath: `/artikel/pra-kehamilan/${artikel.data.record.group_code}/${artikel.data.record.category_slug}`},
						{ label: artikel.data.record.title || '', navigatePath:  `/artikel/pra-kehamilan/${artikel.data.record.group_code}/${artikel.data.record.category_slug}`},
					],
					pathname: 'kehamilan/[sub]',
				},
				artikel: artikel.data.record || {},
				artikelLainnya: artikelLainnya.data.records || [],
				dataComments: dataComments.data.records || [],
				waCommunity: waCommunity.data.records || [],
				categoryArtikel: categoryArtikel.data.records || [],
			},
		};
	},
);

export default SubCategoryPage;
